import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from "react-router-dom";
import { post } from '../../utils/api';
import CategoryForm from './CategoryForm';

const CategoryAdd = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
	const navigate = useNavigate();
    const event = useSelector(state => state.event);
    const [ type, setType ] = useState('main');
	const [ name_ru, setNameRu ] = useState('');
	const [ name_en, setNameEn ] = useState('');
    const [ priority, setPriority ] = useState('0');
    const [ folder, setFolder ] = useState('');
    const [ is_folder, setIsFolder ] = useState(false);
	const [ isLoading, setIsLoading ] = useState(false);
	const [ error, setError ] = useState('');
    const [ success, setSuccess ] = useState('');
    
    // Отправка
	const onSubmit = async () => {
        setIsLoading(true);
        setError('');
        setSuccess('');
        const result = await post('/categories', { name_ru, name_en, type, folder, is_folder, priority, event: event._id });
        if(result.error) {
            setError(result.error);
        } else {
            setSuccess('category.addsuccess');
			navigate('/cabinet/eventview/' + event._id + '/action/updated');
        }
        setIsLoading(false);
	};

    return (
		<div>
	    	<h1>{t('category.addtitle')}</h1>
			{isLoading ? <span>{t('common.loading')}</span> :
            <React.Fragment>
                <CategoryForm
                    success={success}
                    error={error}
                    info={t('category.addsubtitle') + event.name[lang]}
                    submit='category.addsubmit'
                    type={type}
                    nameRu={name_ru}
                    nameEn={name_en}
                    priority={priority}
                    folder={folder}
                    isFolder={is_folder}
                    setType={setType}
                    setNameRu={setNameRu}
                    setNameEn={setNameEn}
                    setIsFolder={setIsFolder}
                    setFolder={setFolder}
                    setPriority={setPriority}
                    onSubmit={onSubmit}
                />
                <p>
                    <NavLink to={'/cabinet/eventview/' + event._id}>{t('category.back')}</NavLink>
                </p>
            </React.Fragment>}
		</div>
	);
};

export default CategoryAdd;
